import type { ConversationPipeline } from './api/conversation/types';

/**
 * Общий перечень обработок, запускаемых над диалогом, в порядке показа пользователю.
 * Один источник для всех мест запуска (массовые действия над диалогами, прогрузка
 * диалогов голосового бота), чтобы наборы обработок и их подписи не расходились.
 */
export const CONVERSATION_PIPELINE_OPTIONS = [
  { value: 'raw_asr_process_pipeline', labelKey: 'common:conversationPipeline.full' },
  { value: 'raw_asr_process_pipeline_no_llm', labelKey: 'common:conversationPipeline.noLlm' },
  { value: 'expert_report_generation_pipeline', labelKey: 'common:conversationPipeline.expertReport' },
  { value: 'extract_raw_attributes_pipeline', labelKey: 'common:conversationPipeline.extractRawAttributes' },
  { value: 'extract_attributes_pipeline', labelKey: 'common:conversationPipeline.extractAttributes' },
] as const satisfies readonly { value: ConversationPipeline; labelKey: string }[];
